module.exports = __webpack_public_path__ + "static/media/beachResort.e7a4b18d.png";